import axios from "axios";
const instance = axios.create({
  baseURL: process.env.VUE_APP_SERVER_SIDE_URL,
});

export default instance;
